/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevCodeIcon32Regular = forwardRef('DevCodeIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M20.558 4.287a1 1 0 0 0-1.916-.574l-7.2 24a1 1 0 0 0 1.916.574l7.2-24Z" }),
        React.createElement("path", { d: "M23.68 8.043a1 1 0 0 1 1.414 0l5.553 5.553a3.4 3.4 0 0 1 0 4.808l-5.553 5.553a1 1 0 0 1-1.414-1.415l5.553-5.552a1.4 1.4 0 0 0 0-1.98L23.68 9.458a1 1 0 0 1 0-1.415Z" }),
        React.createElement("path", { d: "M8.31 8.048a1 1 0 0 1 0 1.414L2.762 15.01a1.4 1.4 0 0 0 0 1.98l5.548 5.548a1 1 0 1 1-1.414 1.414l-5.548-5.548a3.4 3.4 0 0 1 0-4.808l5.548-5.548a1 1 0 0 1 1.414 0Z" })));
});
